// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiftref-checkbox-label {
    margin-top: var(--spacing-05);
    margin-bottom: var(--spacing-05);
    height: 20px;
    display: flex;
    align-items: center;
    color: var(--text-default);
    /*flex-direction: row-reverse;*/
    width: max-content;
    font-family: var(--font-family), sans-serif;
    font-weight: var(--p1-regular-font-weight);
    gap: var(--spacing-10);
    /*position: relative;*/
    user-select: none;
    /*margin-bottom: var(--spacing-10);*/
}
:host([disabled]) .swiftref-checkbox-label {
    color: var(--text-disabled);
}

/*custom checkbox see https://developer.mozilla.org/en-US/docs/Learn/Forms/Advanced_form_styling*/
.swiftref-checkbox {
    margin: 0;
    padding: 0;
    appearance: none;
    position: relative;
    width: 44px;
    height: 20px;
    background: var(--background-strong);
    border-radius: 12px;
    cursor: pointer;
    transition: background-color 0.2s;
    border: 1px solid var(--background-strong);
}
.swiftref-checkbox:after {
    content: "";
    position: absolute;
    left: 1px;
    top: 1px;
    width: 16px;
    height: 16px;
    background: var(--background-default);
    border-radius: 50%;
    transition: transform 0.2s;
}
.swiftref-checkbox:not(:disabled) {
    cursor: pointer;
}

.swiftref-checkbox::before {
    visibility: hidden;
}
.swiftref-checkbox:checked::after {
    content: "";
    position: absolute;
    left: 1px;
    top: 1px;
    width: 16px;
    height: 16px;
    background: var(--background-default);
    border-radius: 50%;
    transition: transform 0.2s;
    transform: translateX(24px);
}


.swiftref-checkbox:disabled  {
    background: var(--background-disabled);
    border: 1px solid var(--background-disabled);
    cursor: not-allowed;
}
.swiftref-checkbox:not(:disabled):checked  {
    background: var(--accent-strong-selected);
}
.swiftref-checkbox:not(:disabled):checked:hover  {
    background: var(--accent-strong-hover);
}
.swiftref-checkbox:not(:disabled):hover  {
    background: var(--background-inverse);
}
.swiftref-checkbox:not(:disabled):focus  {
    border: 1px solid var(--border-focused);
}

:host(:not([message])) swiftref-message {
    margin-top: 0;
    display: none;
}

/*.swiftref-checkbox:checked::before,*/
/*.swiftref-checkbox:indeterminate::before{*/
/*    visibility: unset;*/
/*    color: var(--accent-strong-selected);*/
/*}*/
`, "",{"version":3,"sources":["webpack://./../website_design_system/src/components/form/toggle/style/index.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,+BAA+B;IAC/B,kBAAkB;IAClB,2CAA2C;IAC3C,0CAA0C;IAC1C,sBAAsB;IACtB,sBAAsB;IACtB,iBAAiB;IACjB,oCAAoC;AACxC;AACA;IACI,2BAA2B;AAC/B;;AAEA,iGAAiG;AACjG;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,mBAAmB;IACnB,eAAe;IACf,iCAAiC;IACjC,0CAA0C;AAC9C;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,kBAAkB;IAClB,0BAA0B;IAC1B,2BAA2B;AAC/B;;;AAGA;IACI,sCAAsC;IACtC,4CAA4C;IAC5C,mBAAmB;AACvB;AACA;IACI,yCAAyC;AAC7C;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,qCAAqC;AACzC;AACA;IACI,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,aAAa;AACjB;;AAEA,sCAAsC;AACtC,4CAA4C;AAC5C,yBAAyB;AACzB,4CAA4C;AAC5C,IAAI","sourcesContent":[".swiftref-checkbox-label {\n    margin-top: var(--spacing-05);\n    margin-bottom: var(--spacing-05);\n    height: 20px;\n    display: flex;\n    align-items: center;\n    color: var(--text-default);\n    /*flex-direction: row-reverse;*/\n    width: max-content;\n    font-family: var(--font-family), sans-serif;\n    font-weight: var(--p1-regular-font-weight);\n    gap: var(--spacing-10);\n    /*position: relative;*/\n    user-select: none;\n    /*margin-bottom: var(--spacing-10);*/\n}\n:host([disabled]) .swiftref-checkbox-label {\n    color: var(--text-disabled);\n}\n\n/*custom checkbox see https://developer.mozilla.org/en-US/docs/Learn/Forms/Advanced_form_styling*/\n.swiftref-checkbox {\n    margin: 0;\n    padding: 0;\n    appearance: none;\n    position: relative;\n    width: 44px;\n    height: 20px;\n    background: var(--background-strong);\n    border-radius: 12px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n    border: 1px solid var(--background-strong);\n}\n.swiftref-checkbox:after {\n    content: \"\";\n    position: absolute;\n    left: 1px;\n    top: 1px;\n    width: 16px;\n    height: 16px;\n    background: var(--background-default);\n    border-radius: 50%;\n    transition: transform 0.2s;\n}\n.swiftref-checkbox:not(:disabled) {\n    cursor: pointer;\n}\n\n.swiftref-checkbox::before {\n    visibility: hidden;\n}\n.swiftref-checkbox:checked::after {\n    content: \"\";\n    position: absolute;\n    left: 1px;\n    top: 1px;\n    width: 16px;\n    height: 16px;\n    background: var(--background-default);\n    border-radius: 50%;\n    transition: transform 0.2s;\n    transform: translateX(24px);\n}\n\n\n.swiftref-checkbox:disabled  {\n    background: var(--background-disabled);\n    border: 1px solid var(--background-disabled);\n    cursor: not-allowed;\n}\n.swiftref-checkbox:not(:disabled):checked  {\n    background: var(--accent-strong-selected);\n}\n.swiftref-checkbox:not(:disabled):checked:hover  {\n    background: var(--accent-strong-hover);\n}\n.swiftref-checkbox:not(:disabled):hover  {\n    background: var(--background-inverse);\n}\n.swiftref-checkbox:not(:disabled):focus  {\n    border: 1px solid var(--border-focused);\n}\n\n:host(:not([message])) swiftref-message {\n    margin-top: 0;\n    display: none;\n}\n\n/*.swiftref-checkbox:checked::before,*/\n/*.swiftref-checkbox:indeterminate::before{*/\n/*    visibility: unset;*/\n/*    color: var(--accent-strong-selected);*/\n/*}*/\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
